import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { useLocation } from "wouter";

export default function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [location] = useLocation();

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem("cookie-consent-accepted");
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent-accepted", "true");
    setIsVisible(false);
  };

  const handleMoreInfo = () => {
    // Navigate to privacy policy
    window.location.href = "/privacy";
  };

  // Don't show banner on privacy policy page
  if (location === "/privacy") {
    return null;
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-0 left-0 right-0 z-40 bg-background/95 backdrop-blur-md border-t border-border shadow-2xl"
          dir="rtl"
        >
          <div className="container py-4 px-4 flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Text Content */}
            <div className="flex-1">
              <p className="text-sm leading-relaxed text-foreground" style={{ fontFamily: "var(--font-body)" }}>
                אנחנו משתמשים בעוגיות כדי להעניק לך את החוויה הטובה ביותר. השימוש באתר מהווה הסכמה לשימוש ב-Cookies בהתאם למדיניות הפרטיות שלנו, לצורך שיפור הגלישה והתאמת התכנים עבורך.
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={handleMoreInfo}
                className="px-4 py-2 text-sm font-medium text-accent hover:text-accent-foreground border border-accent rounded-lg transition-colors"
                style={{ fontFamily: "var(--font-body)" }}
              >
                למידע נוסף
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-2 text-sm font-semibold bg-accent text-accent-foreground rounded-lg hover:opacity-90 transition-opacity"
                style={{ fontFamily: "var(--font-body)" }}
              >
                מאשר/ת
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
